// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__o3qlM","buttons":"SendReceipts_buttons__2dy4X","email":"SendReceipts_email__c-kcA","bookApptTitle":"SendReceipts_bookApptTitle__335_V"};